import { EditTabsPattern } from '@/components'
import ConfirmDialogContextProvider from '@/components/ConfirmDialogContext'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, DataDumpEditor, History, SettingsTab } from './tabs'

const tabs = [
  { component: <SettingsTab />, name: 'settings' },
  { component: <DataDumpEditor />, name: 'code-editor' },
  { component: <History />, name: 'version' },
  { component: <ConfigData />, name: 'config' },
]

export const DataDump = () => {
  const { componentID, useUrl } = useComponentProvider()
  return (
    <ConfirmDialogContextProvider>
      <EditTabsPattern
        defaultTab="settings"
        showTabs={!!componentID}
        tabs={tabs}
        urlParams={useUrl}
      />
    </ConfirmDialogContextProvider>
  )
}
